__turbopack_context__.v({
  "backBtn": "OneClickVerification-module-scss-module__0Wkdrq__backBtn",
  "body": "OneClickVerification-module-scss-module__0Wkdrq__body",
  "btn": "OneClickVerification-module-scss-module__0Wkdrq__btn",
  "closeButton": "OneClickVerification-module-scss-module__0Wkdrq__closeButton",
  "desc": "OneClickVerification-module-scss-module__0Wkdrq__desc",
  "label": "OneClickVerification-module-scss-module__0Wkdrq__label",
  "missingData": "OneClickVerification-module-scss-module__0Wkdrq__missingData",
  "missingDataHeader": "OneClickVerification-module-scss-module__0Wkdrq__missingDataHeader",
  "modal": "OneClickVerification-module-scss-module__0Wkdrq__modal",
  "modalContent": "OneClickVerification-module-scss-module__0Wkdrq__modalContent",
  "root": "OneClickVerification-module-scss-module__0Wkdrq__root",
  "row": "OneClickVerification-module-scss-module__0Wkdrq__row",
  "title": "OneClickVerification-module-scss-module__0Wkdrq__title",
});
